import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Copy, themeFontWeight, themeColor } from '@elparking/components'

import { isTruckParking } from '../../../util/isTruckParking'
import getPrice from '../../ParkingCard/getPrice'
import ParkingPrice from '../../ParkingCard/ParkingPrice'
import PriceIcon from './PriceIcon'
import {
    HEIGHT_PX,
    ARROW_HEIGHT_PX,
    SHADOW_WIDTH_PX,
    FONT_SIZE,
} from './constants'

const boxBgColor = props => {
    if (props.isMarked) {
        return themeColor('white')
    }
    return props.isActive
        ? themeColor('main')
        : themeColor('lightGray20')
}

const boxBorderColor = props => {
    if (props.isMarked && !props.isActive) {
        return themeColor('red')
    }

    if (props.isMarked && props.isActive) {
        return themeColor('main')
    }

    if (!props.isMarked && props.isActive) {
        return themeColor('main80')
    }

    return themeColor('gray20')
}

const boxTextColor = props => {
    if (!props.isActive) {
        return themeColor('red')
    }

    if (props.isMarked) {
        return themeColor('main')
    }

    return themeColor('white')
}

const MarkerContainer = styled.div`
    overflow: hidden;
    position: relative;
    text-align: center;
    padding: ${SHADOW_WIDTH_PX}px;
    width: auto;
    height: ${HEIGHT_PX + ARROW_HEIGHT_PX + SHADOW_WIDTH_PX}px;
`

const LabelContainer = styled.div`
    margin: 0 auto;
    display: flex;
    align-items: center;
    width: auto;
    background: ${boxBgColor};
    padding: 6px;
    font-size: ${FONT_SIZE}px;
    font-weight: ${themeFontWeight('book')};
    border-radius: 1px;
    height: ${HEIGHT_PX}px;
    text-align: center;
    color: ${boxTextColor};
    border: 1px solid ${boxBorderColor};
    box-shadow: 0px ${SHADOW_WIDTH_PX}px ${SHADOW_WIDTH_PX}px 0px rgba(0,0,0, 0.2);
    white-space: nowrap;

    &:after {
        position: absolute;
        content: "";
        bottom: 2px;
        left: calc(50% - ${ARROW_HEIGHT_PX}px);
        border-left: ${ARROW_HEIGHT_PX}px solid transparent;
        border-right: ${ARROW_HEIGHT_PX}px solid transparent;
        border-top: ${ARROW_HEIGHT_PX}px solid ${boxBgColor};
        position: absolute;
    }

    &:before {
        position: absolute;
        content: "";
        bottom: 0px;
        left: calc(50% - ${ARROW_HEIGHT_PX + 1}px);
        border-left: ${ARROW_HEIGHT_PX + 1}px solid transparent;
        border-right: ${ARROW_HEIGHT_PX + 1}px solid transparent;
        border-top: ${ARROW_HEIGHT_PX + 1}px solid ${boxBorderColor};
        position: absolute;
    }
`

LabelContainer.propTypes = {
    isActive: PropTypes.bool,
    isMarked: PropTypes.bool,
}

LabelContainer.defaultProps = {
    isActive: false,
    isMarked: false,
}

const TextWrapper = styled(Copy)`
    font-size: ${FONT_SIZE}px;
    color: inherit;
    padding: 0;
`

const CurrencyWrapper = styled(Copy)`
    font-size: 12px;
    color: inherit;
    padding: 0;
`

const PriceMessageWrapper = styled(Copy)`
    font-size: 14px;
    color: inherit;
    padding: 0;
`

const PriceLabel = ({ parking, isMarked }) => {
    const price = getPrice(parking)
    const timeUnit = parking.isActive ? null : parking.estimatedBookingPrice && parking.estimatedBookingPrice.usedPeriodToEstimate

    return (
        <MarkerContainer>
            <LabelContainer isMarked={isMarked} isActive={parking.isActive}>
                <PriceIcon isTruckParking={isTruckParking(parking)} parkingType={parking.typeString} isMarked={isMarked} isActive={parking.isActive} />
                <ParkingPrice
                  price={price}
                  priceWrapper={({children}) => <TextWrapper as='span'>{children}</TextWrapper>}
                  currencyWrapper={({children}) => <CurrencyWrapper as='span'>{children}</CurrencyWrapper>}
                  priceMessageWrapper={({children}) => <PriceMessageWrapper as='span'>{children}</PriceMessageWrapper>}
                  timeUnit={timeUnit}
                />
            </LabelContainer>
        </MarkerContainer>
    )
}

PriceLabel.propTypes = {
    parking: PropTypes.object,
    isMarked: PropTypes.bool,
}

PriceLabel.defaultProps = {
    isMarked: false,
}

export default PriceLabel
